import { isNull, reduce, split, toUpper } from 'lodash'

// this works by coercing input to number by marking it positive, which results in NaN for non-numeric things (except null)
export const isNumeric = (x: number | string | null) => !isNull(x) && +x === +x
export const initials = (str?: string | null, separator?: string) =>
  reduce(
    split(str, separator),
    (acc, word) => (!isNumeric(word) ? `${acc}${toUpper(word.charAt(0))}` : `${acc}${word}`),
    ''
  )
export const formatNumber = (n: number, options?: Intl.NumberFormatOptions) =>
  new Intl.NumberFormat('en-US', options).format(n)

export const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
